import { Col, Row } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { I18n } from '@aws-amplify/core';
import React from 'react';

import { CustomButton, CustomTooltip } from './styles';

interface BackButtonProps {
	onPreviousClick: () => void;
}

export function BackButton({ onPreviousClick }: BackButtonProps): JSX.Element {
	function handleButtonClick() {
		onPreviousClick();
	}

	return (
		<Row justify="center">
			<Col xs={24}>
				<CustomTooltip title={I18n.get('Go back to files selection')}>
					<CustomButton type="link" onClick={handleButtonClick} icon={<LeftOutlined />}>
						{I18n.get('Back')}
					</CustomButton>
				</CustomTooltip>
			</Col>
		</Row>
	);
}
